import React from "react";
import Newsletter from "../newsletter/Newsletter";

const Banner = () => {
  return (
    <section className="relative bg-white z-50">
      <div className=" grid grid-cols-1 lg:grid-cols-2 ">
        <div
          style={{
            backgroundImage:
              "url(" +
              "https://cdn.pmlsound.com/anthem/avm90/images/avm90-mrx-series-banner-bg-only.jpg" +
              ")",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
          onClick={() =>
            window.open(
              "https://www.anthemav.com/products-current/type=av-receiver",
              "_blank"
            )
          }
          className="cursor-pointer"
        >
          <div className="px-8 pt-8">
            <img
              src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-mrx-series-banner-product.png"
              className="mx-auto"
            ></img>
          </div>
          <div className="px-8 pb-8 pt-3">
            <p className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug">
              MRX Series: the perfect <br />
              home theatre experience
            </p>
          </div>
        </div>

        <div className="w-full overflow-hidden bg-gray-600">
          <Newsletter />
        </div>
      </div>
    </section>
  );
};

export default Banner;
